import developmentSettings from "@settings/development.json";
// import qaSettings from "@settings/qa.json";
import preProductionSettings from "@settings/preProduction.json";
import productionSettings from "@settings/production.json";

let settings;
switch (process.env.REACT_APP_ENV) {
  case "development":
    settings = developmentSettings;
    break;
  // case "qa":
  //   settings = qaSettings;
  //   break;
  case "preproduction":
    settings = preProductionSettings;
    break;
  case "production":
    settings = productionSettings;
    break;
  default:
    throw Error("Invalid environment.");
}

export default settings;
